
define('unknown/views/loginView',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/loginModel',
	
	//Shims
	'jquery.sha256'
], function($, _, Backbone, LoginModel){
	var LoginFooterView = Backbone.View.extend({
		events: {
			'click #loginFormSubmit': 'submitLoginForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'loggingIn', this.showNonForm);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'error:notAuthorized', this.showForm);
		},
		
		submitLoginForm: function () {
			this.event.trigger("login");
		},
		
		showForm: function () {
			this.$("#loginFormSubmit").show();
		},
		
		showNonForm: function () {
			this.$("#loginFormSubmit").hide();
		},
	});

	var LoginContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.loginModel = options.loginModel;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'formEnter');
			
			$('#loginBodyContentForm').on("keyup", this.formEnter);
			
			this.listenTo(this.event, 'login', this.submitLogin);
			this.listenTo(this.event, 'loggingIn', this.processing);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'error:notAuthorized', this.form);
			
			//Error handling
			this.listenTo(this.event, 'error:username', this.errorUsername);
			this.listenTo(this.event, 'error:password', this.errorPassword);
			
		},
		
		submitLogin: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("loggingIn");
				
				//Attempt to login user
				this.submittedData.isSubmitted = true;
				
				this.loginModel.save({
					userName: this.$("#loginUserNameInput").val(),
					password : this.$("#loginPasswordInput").val() ? $.sha256(this.$("#loginPasswordInput").val()) : ""
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}			
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("login");
				return false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#loginBodyContentForm").hide();
			this.$("#loginBodyContentProcessing").hide();
			
			//Hide error messages
			this.$("#loginUserNameGrp").removeClass("error");
			this.$("#loginUserNameInput").removeClass("error");
			this.$("#loginUserNameErrMsg").hide();
			
			this.$("#loginPasswordGrp").removeClass("error");
			this.$("#loginPasswordInput").removeClass("error");
			this.$("#loginPasswordErrMsg").hide();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#loginBodyContentProcessing").show();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#loginBodyContentForm").show();
		},
		
		errorUsername : function (errorCode) {
			this.$("#loginUserNameGrp").addClass("error");
			this.$("#loginUserNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#loginUserNameErrMsg").html("Username is empty");
					this.$("#loginUserNameErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#loginUserNameErrMsg").html("Username must be between 5 and 20 characters long");
					this.$("#loginUserNameErrMsg").show();
					break;
				case "ALPHANUM": 
					this.$("#loginUserNameErrMsg").html("Username may only contain alpha numeric characters");
					this.$("#loginUserNameErrMsg").show();
					break;
				case "NOTAUTH": 
					break;
				default : 
					this.$("#loginUserNameErrMsg").html("Username is invalid");
			}
		},
		
		errorPassword : function (errorCode) {
			this.$("#loginPasswordGrp").addClass("error");
			this.$("#loginPasswordInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#loginPasswordErrMsg").html("Password is empty");
					this.$("#loginPasswordErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#loginPasswordErrMsg").html("Password must be at least 5 characters long");
					this.$("#loginPasswordErrMsg").show();
					break;
				case "NOTAUTH": 
					break;
				default : 
					this.$("#loginPasswordErrMsg").html("Password is invalid");
			}
		},
	});

	var LoginMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'loggingIn', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'error:notAuthorized', this.notAuthorized);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#loginBodyMessageError").hide();
			this.$("#loginBodyMessageNotAuthorized").hide();
			this.$("#loginBodyMessageProcessing").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#loginBodyMessageError").show();
		},
		
		notAuthorized: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#loginBodyMessageNotAuthorized").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#loginBodyMessageProcessing").show();
		},
	});
	
	var LoginView = Backbone.View.extend({
		el: $("#loginContent"),
		
		initialize: function(options) {
			this.loginModel = options.loginModel;
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.message = new LoginMessageView({el: this.$("#loginBodyMessage"), event: this.event});
			this.content = new LoginContentView({
				el: this.$("#loginBodyContent"), 
				event: this.event, 
				loginModel: this.loginModel,
				submittedData: this.submittedData});
			this.footer = new LoginFooterView({el: this.$("#loginFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.routeUser);
			this.listenTo(this.event, 'savingError', this.loginError);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		routeUser: function () {
			this.submittedData.isSubmitted = false;
			window.location.href = "/draftapp/dashboard";
			return this;
		},
		
		loginError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 401) {
					//Username/pass invalid
					this.event.trigger("error:notAuthorized");
					this.event.trigger("error:username", "NOTAUTH");
					this.event.trigger("error:password", "NOTAUTH");
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		}
	});
	
	return LoginView;  
});